const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/synedra.ts';
import { createPatapiCall, HttpMethod } from 'App/utils/fetchUtils';
import { kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';

export const LOAD_SYNEDRA_TOKEN = kisapiActionTypes('PATAPP_GET_SYNEDRA_IFRAME_URL');

export function actionLoadSynedraToken() {
    const endpoint = 'toberenamed/synedraToken';
    return createPatapiCall(LOAD_SYNEDRA_TOKEN, endpoint, HttpMethod.GET);
}
